// src/app/core/constants/app.constants.ts

/**
 * localStorage map of userId -> achievement badges whose "Congratulations!"
 * popup has already been shown (see CongratulationPopupService).
 *
 * Lives here rather than beside the service so AuthService can preserve it in
 * clearStorageKeepRemember() without importing the service that depends on it.
 */
export const ACHIEVEMENT_POPUP_SEEN_KEY = 'achievement_popup_seen';

export const APP_CONFIG = {
  APP_NAME: 'Clinical Enrollment',

  COPYRIGHT_YEAR: new Date().getFullYear(),

  ROUTES: {
    LOGIN: '/auth/login',
    FORGOT_PASSWORD: '/auth/forgot-password',
    DASHBOARD: '/dashboard',
    PROFILE: '/profile',
    APPOINTMENTS: '/appointments'
  },

  STORAGE_KEYS: {
    REMEMBER_ME: 'remember_me',
    REMEMBER_EMAIL: 'remember_email',
    REMEMBER_PASSWORD: 'remember_password'
  },
  SOCKET_EVENTS: {
    DEAL_CREATED: "dealCreated",
    DEAL_UPDATED: "dealUpdated",
    NEW_NOTIFICATION: "newNotification",
    NOTIFICATION_UPDATED: "notificationUpdated",
  },
  /**
   * Which list a pin belongs to. A pin is per coordinator and per list, held
   * in the backend's dealpinorders collection, so one coordinator has at most
   * three: the Todo page and All Referrals' Today section share TODAY, and All
   * Referrals' other two sections own the rest. Must stay identical to
   * PIN_TYPE in backend/src/constants/status.ts.
   */
  PIN_TYPE: {
    TODAY: 'today',
    TOMORROW: 'tomorrow',
    ALL_REFERRAL: 'allReferral'
  },
  /**
   * The complete referral/deal workflow status list. These strings are the
   * exact values stored in deals.status, so they must stay identical to
   * ALL_STATUS in backend/src/constants/status.ts.
   */
  ALL_STATUS: {
    NEW: 'New',
    FIRST_ATTEMPT_NO_CONTACT: '1st Attempt - No Contact',
    SECOND_ATTEMPT_NO_CONTACT: '2nd Attempt - No Contact',
    THIRD_ATTEMPT_NO_CONTACT: '3rd Attempt - No Contact',
    UNABLE_TO_REACH_AFTER_4_ATTEMPTS: 'Unable to Reach After 4 Attempts',
    SCHEDULED_FOR_PRESCREEN: 'Scheduled for Prescreen',
    NO_SHOW_FOR_PRESCREEN: 'No Show for Prescreen',
    SCHEDULED_FOR_ONSITE_SCREENING_ICF: 'Scheduled for On-Site Screening/ICF',
    NO_SHOW_FOR_SCREENING: 'No Show for Screening',
    INFORMED_CONSENT_SIGNED: 'Informed Consent Signed',
    DISQUALIFIED: 'Disqualified',
    FAILED_SCREENING: 'Failed Screening',
    RANDOMIZED: 'Randomized',
    UNRESPONSIVE: 'Unresponsive',
    NO_LONGER_INTERESTED: 'No Longer Interested',
    ON_HOLD_PENDING_MEDICAL_RECORD: 'On Hold - Pending Medical Record',
    ON_HOLD_PATIENT_REASON: "On Hold - Patient's Reason"
  },
  /**
   * Statuses that close a referral out: no further outreach is expected, so
   * nothing is counting down against them. Mirrors TERMINAL_STATUS in
   * backend/src/constants/status.ts — keep the two in step.
   *
   * Informed Consent Signed is deliberately absent; it is treated as an
   * ongoing status, matching the backend.
   */
  TERMINAL_STATUS: [
    'Disqualified',
    'Failed Screening',
    'Randomized',
    'Unresponsive',
    'No Longer Interested',
    'Unable to Reach After 4 Attempts'
  ],
  /**
   * Reporting windows offered by the Activity Summary popup. `value` is the
   * exact key the /deals/activitySummary API expects (backend
   * ACTIVITY_SUMMARY_PERIOD), `label` is what the tab and the copied text show.
   */
  ACTIVITY_SUMMARY_PERIODS: [
    { value: '7d', label: '7 Days' },
    { value: '30d', label: '30 Days' },
    { value: 'all', label: 'All Time' }
  ],
  START_WORKING_TIME: 9, //9am
  END_WORKING_TIME: 21,  //9pm
  STREAK_POINTS: {
    gold: 4,
    silver: 3,
    bronze: 2,
    expired: 1
  },
};